export default __webpack_public_path__ + "static/media/arw-04130.3336409e.jpg";